var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVariableIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 3.75781H5C3.9 3.75781 3 4.65781 3 5.75781V19.7578C3 20.8578 3.9 21.7578 5 21.7578H19C20.1 21.7578 21 20.8578 21 19.7578V5.75781C21 4.65781 20.1 3.75781 19 3.75781ZM19 19.7578H5V5.75781H19V19.7578Z",
    fill: "#8DC63F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 12.7578H7V17.7578H9V12.7578Z",
    fill: "#8DC63F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17 7.75781H15V17.7578H17V7.75781Z",
    fill: "#8DC63F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13 14.7578H11V17.7578H13V14.7578Z",
    fill: "#8DC63F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13 10.7578H11V12.7578H13V10.7578Z",
    fill: "#8DC63F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVariableIcon);
export default __webpack_public_path__ + "static/media/variable-icon.8e71543cd18b3e9e3a4e4fc4fb1aa1a5.svg";
export { ForwardRef as ReactComponent };